export default __webpack_public_path__ + "static/media/droneAppNews.ae1434f6.pdf";